module.exports = __webpack_public_path__ + "img/charts.731d5bdc.svg";